import React from "react";
import { DatePicker } from "antd";
import moment from "moment";
import { CustomFormItemInputWithBorder } from "../Form";

class DateComponent extends React.Component {
  render() {
    const {
      getFieldDecorator,
      title,
      decodator,
      value,
      showTime,
      required,
      placeholder,
      inLine,
      disabled,
      onChange,
      onOpenChange,
      disabledDate,
      style,
      format,
      message,
    } = this.props;

    return (
      <div>
        <CustomFormItemInputWithBorder
          labelCol={{
            xs: { span: inLine ? 12 : 24 },
            sm: { span: inLine ? 12 : 24 },
            lg: { span: inLine ? 7 : 24 },
            xl: { span: inLine ? 7 : 24 },
          }}
          wrapperCol={{
            xs: { span: inLine ? 12 : 24 },
            sm: { span: inLine ? 12 : 24 },
            lg: { span: inLine ? 16 : 24 },
            xl: { span: inLine ? 16 : 24 },
          }}
          label={title}
        >
          {getFieldDecorator(decodator, {
            initialValue: (value && moment(value)) || undefined,
            rules: [
              {
                required,
                message: message || "El campo no puede quedar vacio.",
              },
            ],
          })(
            <DatePicker
              placeholder={placeholder}
              showTime={showTime}
              disabled={disabled}
              onChange={onChange}
              onOpenChange={onOpenChange}
              disabledDate={disabledDate}
              style={style}
              format={format}
            />
          )}
        </CustomFormItemInputWithBorder>
      </div>
    );
  }
}

export default DateComponent;
